/** Shortcuts shown on the mobile airport pickers before the traveller types anything. */
export const POPULAR_AIRPORTS = [
  { name: 'Jomo Kenyatta International Airport', city: 'Nairobi', country: 'Kenya', iata: 'NBO' },
  { name: 'Wilson Airport', city: 'Nairobi', country: 'Kenya', iata: 'WIL' },
  { name: 'Moi International Airport', city: 'Mombasa', country: 'Kenya', iata: 'MBA' },
  { name: 'Kisumu International Airport', city: 'Kisumu', country: 'Kenya', iata: 'KIS' },
  { name: 'Eldoret International Airport', city: 'Eldoret', country: 'Kenya', iata: 'EDL' },
  { name: 'Ukunda Airstrip', city: 'Diani', country: 'Kenya', iata: 'UKA' },
  { name: 'Malindi Airport', city: 'Malindi', country: 'Kenya', iata: 'MYD' }
];
